import { NavLink } from 'react-router-dom';

import { NAV_GROUPS } from './nav';
import styles from './Sidebar.module.css';

export function Sidebar() {
  return (
    <aside className={styles.sidebar}>
      {NAV_GROUPS.map((group) => (
        <div key={group.label} className={styles.group}>
          <div className={styles.groupLabel}>{group.label}</div>
          <nav className={styles.nav}>
            {group.items.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  title={item.hint}
                  className={({ isActive }) =>
                    isActive ? `${styles.item} ${styles.active}` : styles.item
                  }
                >
                  <span className={styles.mark} aria-hidden="true" />
                  <Icon size={16} strokeWidth={1.5} />
                  <span className={styles.label}>{item.label}</span>
                </NavLink>
              );
            })}
          </nav>
        </div>
      ))}

    </aside>
  );
}
